import appSync from '@/_services/appsync.service.js'
import gql from 'graphql-tag'
import { plannerService } from '@/_services'

export const scheduleServices = {
  optimizeScheduleContext,
  saveOptimizedDrops,
  getSchedule
}

const GET_SCHEDULE = gql`query getSchedule($input: GetScheduleInput!) {
  getSchedule(input: $input) {
    schedule {
          stops {
            stopIndex
            type
            location {
              id
              name
              ref
              equipment
              accessibility
              address {
                street
                streetNo
                city
                country
                countryCode
                postalCode
              }
              organization {
                id
                name
                ref
              }
              coordinates {
                lat
                lng
              }
            }
            arrival
            departure
            timeSpent
          }
          connections {
            stopIndexFrom
            stopIndexTo
            distance
            duration
          }
          metrics {
            totalDistance
            totalDuration
            numberOfLocations
            numberOfOtherStops
          }
        }
      }
    }`
const OPTIMIZE_SCHEDULE_FOR_SHIPMENT_CONTEXT = gql`query getSchedule($input: GetScheduleInput!)
{
  getSchedule(input: $input)
  {
    schedule {
      stops {
        stopIndex
        type
        location {
          id
          name
          ref
          equipment
          accessibility
          address {
            street
            streetNo
            city
            country
            countryCode
            postalCode
          }
          organization {
            id
            name
            ref
          }
          coordinates {
            lat
            lng
          }
        }
        arrival
        departure
        timeSpent
      }
      connections {
        stopIndexFrom
        stopIndexTo
        distance
        duration
      }
      metrics {
        totalDistance
        totalDuration
        numberOfLocations
        numberOfOtherStops
      }
    }
  }
}`

async function optimizeScheduleContext ({ optimize, drops, vehicle }) {
  try {
    const response = await appSync.query({
      query: OPTIMIZE_SCHEDULE_FOR_SHIPMENT_CONTEXT,
      variables: {
        input: {
          optimize,
          drops,
          vehicle
        }
      },
      fetchPolicy: 'no-cache'
    })
    if (response.data.getSchedule.skippedDrops != null) {
      if (response.data.getSchedule.skippedDrops.length > 0) {
        return { skippedDrops: response.data.getSchedule.skippedDrops, error: 'shipment_cannot_be_optimized' }
      }
    }
    return response.data.getSchedule.schedule
  } catch (error) {
    return Promise.reject(error)
  }
}
async function getSchedule ({ optimize = false, drops, vehicle }) {
  try {
    const response = await appSync.query({
      query: GET_SCHEDULE,
      variables: {
        input: {
          optimize,
          drops,
          vehicle
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.getSchedule.schedule
  } catch (error) {
    return Promise.reject(error)
  }
}

function saveOptimizedDrops ({ drops }) {
  return new Promise((resolve, reject) => {
    // resolve(true)
    Promise.all(drops.map(async (drop, index) => {
      const responseDeparture = await plannerService.plannerSetDropDeparture(drop)
      const responseArrival = await plannerService.plannerSetDropArrival(drop)
      return { responseDeparture, responseArrival }
    })).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}
